
<template>
  <div v-if="loader">
  <!-- init preloader -->
    <div class="sk-folding-cube">
      <div class="sk-cube1 sk-cube"></div>
      <div class="sk-cube2 sk-cube"></div>
      <div class="sk-cube4 sk-cube"></div>
      <div class="sk-cube3 sk-cube"></div>
    </div>
    <div id="overlay"></div>
  </div>
    <!-- end preloader -->
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name:'Loader',
  data(){
    return{
    }
  },
  methods:{
      ...mapMutations(["setLoader"])
  },
  computed:{
      ...mapGetters(["loader"])
  }
};
</script>

